"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_XC_REBASES = exports.GET_XC_CONTROLLER_DATA = void 0;
const XC_REBASE_FRAGMENT = `
  {
    id
    controller {
      id
    }
    epoch
    timestamp
    supply
    previousSupply
    precentageChange
    supplyAdjustment
  }
`;
exports.GET_XC_CONTROLLER_DATA = `
  query GetXCControllerData ($id: ID!) {
    xccontrollers(where: { id: $id }) {
      id
      lastRebase ${XC_REBASE_FRAGMENT}
    }
  }
`;
exports.GET_XC_REBASES = `
  query GetXCRebases ($id: ID!, $first: Int!, $skip: Int) {
    xcrebases(where: { controller: $id },
      first: $first,
      skip: $skip,
      orderBy: timestamp,
      orderDirection: desc) ${XC_REBASE_FRAGMENT}
  }
`;
//# sourceMappingURL=xc_controller.js.map